module.exports = __webpack_public_path__ + "static/WEDDING E&M-529-9bcaa72b05309ebce33253de7e13347c.jpg";